import React from 'react';
import { cn } from '../cn';
import { Button } from '../Button/Button';
import {
  IconCheckDark,
  IconError,
  IconInfo,
  IconWarning
} from '../Icons';
import { Typography } from '../Typography/Typography';

export type TBannerProps = React.PropsWithChildren<{
  color: 'primary' | 'success' |'warning' | 'error' | 'riac',
  onDismiss?: () => void,
  show?: boolean,
  className?: string,
  typographyClassName?: string,
  size?: 'sm' | 'md' | 'lg',
  shadow?: boolean,
  centerIconVertically?: boolean,
  noIcon?: boolean,
  noBorder?: boolean,
  centeredTextWithIcon?: boolean;
}>;

export const Banner = ({noBorder, centeredTextWithIcon, noIcon, size, shadow, children, className, typographyClassName, color, onDismiss, show, centerIconVertically}: TBannerProps) => {
  return (
    <div
      className={cn(
        'border-1 border-black',
        color === 'primary' && 'border-primary-darker bg-primary-lightest text-primary-darker',
        color === 'success' && 'border-success-darker bg-success-lightest text-success-darker',
        color === 'warning' && 'border-warning-darker bg-warning-lightest text-warning-darker',
        color === 'error' && 'border-error-darker bg-error-lightest text-error-darker',
        color === 'riac' && 'border-neutral-200 bg-neutral-200 text-neutral-900 dark ',
        'flex flex-row items-start justify-center',
        centerIconVertically && 'items-center',
        (!size || size === 'md') && [
          'py-4 px-6 md:px-10 gap-2',
          noIcon && 'px-10'
        ],
        size === 'sm' && [
          'p-2 gap-2',
          noIcon && 'px-5',
        ],
        size === 'lg' && [
          'py-6 px-8 md:px-12 gap-2',
          noIcon && 'px-12',
        ],
        noBorder === true && 'border-0',
        centeredTextWithIcon && 'items-center',
        className,
        (!show && show !== undefined) && 'hidden',
      )}
      style={{
        boxShadow: shadow && '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -4px rgba(0, 0, 0, 0.1)' || undefined,
      }}
    >
      {!noIcon ? <>
        {color === 'riac' && <IconInfo className='text-sc-gold-50'/>}
        {color === 'primary' && <IconInfo/>}
        {color === 'error' && <IconError/>}
        {color === 'warning' && <IconWarning/>}
        {color === 'success' && <IconCheckDark/>}
      </> : ''}

      <Typography className={cn(
        'flex-1 text-base leading-6',
        centeredTextWithIcon && 'max-w-max',
        typographyClassName
      )} weight='bold'>
        {children}
      </Typography>
      {onDismiss && <Button unstyled aria-label='Dismiss banner' onPress={onDismiss}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Button>}
    </div>
  );
}